module.exports = __webpack_public_path__ + "img/changePassword.edaff1c0.svg";